import React from "react";
import { Row, Col, Card, CardBody, Button } from "reactstrap";

const cardShell = {
  background: "var(--vz-secondary-bg, #fff)",
  border: "1px solid var(--vz-border-color)",
  borderRadius: 10,
  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  overflow: "hidden",
};


const SoarIntegrationsTable = () => {
  const integrations = [
    {
      name: "Splunk Enterprise",
      type: "SIEM",
      status: "Connected",
      statusColor: "primary",
      lastSync: "2024-05-15 10:30 AM",
    },
    {
      name: "CrowdStrike Falcon",
      type: "EDR",
      status: "Connected",
      statusColor: "primary",
      lastSync: "2024-05-15 10:45 AM",
    },
    {
      name: "Microsoft Sentinel",
      type: "SIEM",
      status: "Disconnected",
      statusColor: "danger",
      lastSync: "2024-05-14 02:00 PM",
    },
    {
      name: "Palo Alto Networks",
      type: "Firewall",
      status: "Pending",
      statusColor: "primary",
      lastSync: "Never",
    },
    {
      name: "Carbon Black Cloud",
      type: "Endpoint Security",
      status: "Connected",
      statusColor: "primary",
      lastSync: "2024-05-15 11:00 AM",
    },
  ];
  const getBadgeStatus = (status) => {
    switch (status) {
      case "Disconnected": return { color: "#dc2626", border: "1px solid rgba(239, 68, 68, 0.3)" };
      case "Connected": return {color: "#FF5B00", border: "1px solid rgba(251, 191, 36, 0.3)" };
      case "Pending": return {color: "#ec8e50ff", border: "1px solid rgba(132, 167, 38, 0.3)" };
      default: return {color: "#374151", border: "1px solid #d1d5db" };
    }
  };


  return (
    <>
      <Row className="align-items-start mb-4">
        <Col>
          <h4 className="fw-bold mb-1">SOAR Integrations</h4>
          <p className="text-muted mb-3">
            Manage and connect your Security Orchestration, Automation, and Response (SOAR)
            platforms to streamline operations and enhance threat detection.
          </p>
          <Button style={{ backgroundColor: "rgba(7, 82, 57, 0.1)",
                          color: "#918a8aff",
                          border: "1px solid #FF5B00",
                          padding: "6px 14px",
                          borderRadius: "6px",
                          fontSize: "11px",
                          fontWeight: "500",
                          textDecoration: "none"}} className="shadow-sm fw-medium">
            ✚ Add New Integration
          </Button>
        </Col>
      </Row>

      <Card className="shadow-sm border-0" style={cardShell}>
        <CardBody>
          <h5 className="fw-semibold mb-5">Active Integrations</h5>
          <div className="table-responsive table-card">
            <table className="table align-middle table-nowrap table-striped-columns mb-0">
              <thead className="table-white">
                <tr>
                  <th scope="col">Integration Name</th>
                  <th scope="col">Type</th>
                  <th scope="col">Status</th>
                  <th scope="col">Last Sync</th>
                  <th scope="col" style={{ width: "180px" }}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {integrations.map((item, index) => (
                  <tr key={index}>
                    <td className="fw-medium">{item.name}</td>
                    <td>{item.type}</td>
                    <td>
                     <span className="badge rounded-pill " style={getBadgeStatus(item.status)}>{item.status}</span>
                    </td>
                    <td>{item.lastSync}</td>
                    <td>
                      {item.status === "Disconnected" ? (
                        <>
                          <Button size="sm" color="success" className="me-2 border btn btn-outline-success">
                            Configure
                          </Button>
                          <Button size="sm" color="danger" className="fw-medium btn btn-outline-danger">
                            Retry
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button size="sm" color="success" className="me-2 border btn btn-outline-success">
                            Configure
                          </Button>
                          <Button size="sm" color="primary" className="border btn btn-outline-primary">
                            View Logs
                          </Button>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CardBody>
      </Card>
    </>
  );
};

export default SoarIntegrationsTable;
